import styled from 'styled-components';
import { device } from '../../../styles/devices';

export const ModalWithImageWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  @media ${device.tablet} {
    flex-direction: row;
  }
`;

export const Box = styled.div`
  flex: 1;
  width: 100%;
`;

export const ModalImage = styled.img`
  max-width: 100%;
  padding-top: 16px;
  margin-bottom: 10px;

  @media ${device.tablet} {
    margin-bottom: 0;
  }
`;

export const ModalHeader = styled.p`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  line-height: 24px;
`;

export const ModalText = styled.p`
  font-size: 16px;
  line-height: 24px;

  & ul {
    padding: 10px 0;
  }
`;

export const ModalTextWrapper = styled.div`
  padding: 10px;
  font-family: 'Audi Type';

  @media ${device.tablet} {
    padding: 48px;
  }
`;
